module.exports = __webpack_public_path__ + "static/media/quote_top.5d086ba8.svg";